import React from 'react';

import IssuesModule from '../issues/components/IssuesModule';
import InventoryPermissionGuard from './InventoryPermissionGuard';

export default function InventoryIssuesModule() {
  return (
    <InventoryPermissionGuard
      permissions={[
        { resource: 'inventory.issue', action: 'read' },
        { resource: 'inventory.item', action: 'read' },
      ]}
    >
      <IssuesModule />
    </InventoryPermissionGuard>
  );
}